import React, { Component } from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

import poLogo from "../../assets/images/logo/po-logo.png";

const XIcon = () => <span className="x-social-icon">X</span>;

const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/paul.olle.3/" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/paulolle/" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/paulolle971/" },
  { Social: <XIcon />, link: "https://x.com/StyxisReal" },
];
class HeaderThree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
    this.menuTrigger = this.menuTrigger.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleAnchorClick = this.handleAnchorClick.bind(this);
    this.closeSidebar = this.closeSidebar.bind(this);
    this.lockPageScroll = this.lockPageScroll.bind(this);
    this.unlockPageScroll = this.unlockPageScroll.bind(this);
    this.preventBackgroundScroll = this.preventBackgroundScroll.bind(this);
    this.lockedScrollY = 0;
    this.scrollLockActive = false;
    this.previousBodyOverflow = "";
    this.previousHtmlOverflow = "";
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.menuOpen === this.state.menuOpen) {
      return;
    }

    if (this.state.menuOpen) {
      this.lockPageScroll();
    } else {
      this.unlockPageScroll();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    this.unlockPageScroll();
  }

  menuTrigger() {
    this.setState((state) => ({ menuOpen: !state.menuOpen }));
  }

  closeSidebar() {
    this.setState({ menuOpen: false });
  }

  lockPageScroll() {
    if (this.scrollLockActive || window.innerWidth > 991) {
      return;
    }

    this.lockedScrollY = window.scrollY || window.pageYOffset || 0;
    this.previousBodyOverflow = document.body.style.overflow;
    this.previousHtmlOverflow = document.documentElement.style.overflow;
    document.documentElement.classList.add("portfolio-menu-locked");
    document.body.classList.add("portfolio-menu-locked");
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.addEventListener("wheel", this.preventBackgroundScroll, { passive: false });
    document.addEventListener("touchmove", this.preventBackgroundScroll, { passive: false });
    this.scrollLockActive = true;
  }

  unlockPageScroll() {
    if (!this.scrollLockActive) {
      return;
    }

    document.documentElement.classList.remove("portfolio-menu-locked");
    document.body.classList.remove("portfolio-menu-locked");
    document.documentElement.style.overflow = this.previousHtmlOverflow;
    document.body.style.overflow = this.previousBodyOverflow;
    document.removeEventListener("wheel", this.preventBackgroundScroll);
    document.removeEventListener("touchmove", this.preventBackgroundScroll);
    window.scrollTo(0, this.lockedScrollY);
    this.scrollLockActive = false;
  }

  preventBackgroundScroll(event) {
    const menu = document.querySelector(".mainmenunav ul.mainmenu");

    if (menu && menu.contains(event.target)) {
      return;
    }

    event.preventDefault();
  }

  handleAnchorClick(event) {
    const href = event.currentTarget.getAttribute("href");
    const target = href && document.querySelector(href);

    if (!target) {
      this.closeSidebar();
      return;
    }

    event.preventDefault();
    this.setState({ menuOpen: false }, () => {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.pushState(null, "", href);
    });
  }

  handleScroll() {
    const header = document.querySelector(".header--fixed");

    if (!header) {
      return;
    }

    if (window.scrollY > 100) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  }

  render() {
    const { color = "default-color" } = this.props;
    const { menuOpen } = this.state;

    return (
      <header className={`header-area header-style-two header--fixed ${color}`}>
        <div className={`header-wrapper ${menuOpen ? "menu-open" : ""}`}>
          <div className="header-left d-flex align-items-center">
            <div className="logo">
              <a className="site-brand" href={this.props.homeLink} aria-label="Paul Olle home">
                <img className="site-brand-logo" src={poLogo} alt="" />
                <span className="site-brand-text">
                  <strong>Paul Olle</strong>
                  <em>Software Engineer</em>
                </span>
              </a>
            </div>
            <nav className="mainmenunav d-lg-block ml--50" aria-label="Main navigation">
              <ul className="mainmenu">
                <li className="mobile-menu-status" aria-hidden="true">
                  <span>~/portfolio/nav</span>
                  <em>online</em>
                </li>
                <li>
                  <a onClick={this.handleAnchorClick} href="#home">
                    Home
                  </a>
                </li>
                <li>
                  <a onClick={this.handleAnchorClick} href="#about">
                    About
                  </a>
                </li>
                <li>
                  <a onClick={this.handleAnchorClick} href="#service">
                    Skills
                  </a>
                </li>
                <li>
                  <a onClick={this.handleAnchorClick} href="#portfolio">
                    Projects
                  </a>
                </li>
                <li>
                  <a onClick={this.handleAnchorClick} href="#blog">
                    Career
                  </a>
                </li>
                <li>
                  <a onClick={this.handleAnchorClick} href="#contact">
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div className="header-right">
            <div className="social-share-inner">
              <ul className="social-share social-style--2 color-black d-flex justify-content-start liststyle">
                {SocialShare.map((val, i) => (
                  <li key={i}>
                    <a href={`${val.link}`} target="_blank" rel="noreferrer">{val.Social}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="humberger-menu d-block d-lg-none pl--20">
              <button
                type="button"
                onClick={this.menuTrigger}
                className="menutrigger text-white mobile-menu-toggle"
                aria-label={menuOpen ? "Close menu" : "Open menu"}
                aria-expanded={menuOpen}
              >
                <span className="menu-bar" />
                <span className="menu-bar" />
                <span className="menu-bar" />
              </button>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default HeaderThree;
